import React, { Component } from 'react';
import { Notification } from 'react-bulma-components'
import './banner.css'
class BannerFeedback extends Component {

  onDismiss = (e) => { 
    e.stopPropagation()
    e.preventDefault()
    this.props.onDismiss()
  }

  render() {

    const {
      showMessage,
      messageContent,
      messageType,
      showDismiss,
      containerClassName
    } = this.props

    const color = messageType === 'success' ? 'success' : 'danger'
    const className = `twisted-toast ${containerClassName}`
    return !showMessage ? null : (
      <div className={className}>
        <Notification color={color}>
          {messageContent}
          {showDismiss && <button className="delete" onClick={this.onDismiss}></button>}
        </Notification>
      </div>
    )

  }
}
export default BannerFeedback

BannerFeedback.defaultProps = {
    showMessage : false,
    messageContent: "Updated",
    messageType: 'success',
    showDismiss: true,
    containerClassName: '',
    onDismiss: () => {}
}